function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledScrollTopFabComponent } from "./scroll-top-fab-component.scss";
import ArrowUp from "/static/svg/careers/up.svg";
import classnames from "classnames";
class ScrollTopFabComponent extends PureComponent {
    componentDidMount() {
        if (typeof window !== "undefined") {
            window.onscroll = ()=>{
                let currentScrollPos = window.pageYOffset;
                let maxScroll = document.body.scrollHeight - window.innerHeight;
                if (currentScrollPos > 0 && currentScrollPos < maxScroll) {
                    this.setState({
                        show: true
                    });
                } else {
                    this.setState({
                        show: false
                    });
                }
            };
        }
    }
    render() {
        const { wrapperStyles } = this.props;
        const { show } = this.state;
        return /*#__PURE__*/ _jsx(StyledScrollTopFabComponent, {
            className: classnames("scroll-top-fab-component", "tooltip-trigger", {
                "is-shown": show
            }),
            style: _object_spread({}, wrapperStyles),
            onClick: this.onClick,
            children: /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(ArrowUp, {}),
                    /*#__PURE__*/ _jsx("div", {
                        className: "tooltip-contents",
                        children: "Return to top"
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "onClick", ()=>{
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        });
        this.state = {
            show: false
        };
    }
}
ScrollTopFabComponent.defaultProps = {
    wrapperStyles: {}
};
export default ScrollTopFabComponent;
